const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  admin: state => state.user.admin,
  nameid: state => state.user.nameid,
  roles: state => state.user.roles,
  enterpriseInfo: state => state.enterprise.enterpriseInfo,
  currentEid: state => state.enterprise.currentEid,
  currentMarketID: state => state.enterprise.currentMarketID,
  userInfo: state => state.user.userInfo
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js